import * as types from "./types";

import {
    getComplaintsListAxios,
    deleteComplaintsAxios,
    postComplaintsAxios,
    putComplaintsAxios,
    getComplaintsByIdAxios,
    postFeebackAxios,
    getComplaintFeedbackById,
    deleteComplaintFeedbackAxios,
    updateComplaintStatus
} from "./services";

export async function getComplaintsListAction({ commit }) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        const { data } = await getComplaintsListAxios();
        commit(types.GET_COMPLAINTS_LIST, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}

export async function removeComplaintsAction({ commit }, payload) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        await deleteComplaintsAxios(payload);
        commit(types.REMOVE_COMPLAINTS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}

export async function addComplaintsAction({ commit }, payload) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        const { data } = await postComplaintsAxios(payload);
        commit(types.ADD_COMPLAINTS, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}

export async function updateComplaintsAction({ commit }, { id, payload }) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        await putComplaintsAxios(id, payload);
        commit(types.UPDATE_COMPLAINTS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}

export async function getComplaintsByIdAction({ commit }, payload) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        const { data } = await getComplaintsByIdAxios(payload);
        commit(types.GET_COMPLAINT_ID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}




export async function addComplaintFeedbackAction({ commit }, payload) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        const { data } = await postFeebackAxios(payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}

export async function getComplaintFeedbackAction({ commit }, id) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        const { data } = await getComplaintFeedbackById(id);
        commit(types.GET_FEEDBACK_ID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}


export async function deleteComplaintFeedbackAction({ commit }, id) {
    commit(types.LOADING_COMPLAINTS, true);
    try {
        await deleteComplaintFeedbackAxios(id);
        commit(types.REMOVE_FEEDBACK, id);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}

export async function updateComplaintStatusAction({ commit }, payload) {
    commit(types.LOADING_COMPLAINTS, true);

    try {
        await updateComplaintStatus(payload);
         commit(types.UPDATE_COMPLAINT_STATUS, payload);
    } catch (e) {
        throw e;
    } finally {
        commit(types.LOADING_COMPLAINTS, false);
    }
}

